import React from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';
import useGeoData from '../../../store/useGeoData';
import type { GeoDataState } from '../../../store/types';
import ToggleButton from '../../../common/inputs/ToggleButton'; // Importa ToggleButton
import { RangeSlider } from '../../../common/inputs/RangeSlider/RangeSlider'; // Importa RangeSlider

const TerrainPanel: React.FC = () => {
  // Seleziona solo le proprietà necessarie usando useStoreWithEqualityFn
  const { isTerrainActive, terrainExaggeration, setTerrainActive, setTerrainExaggeration } = useStoreWithEqualityFn(
    useGeoData, // Passa l'hook dello store
    (state: GeoDataState) => ({
      isTerrainActive: state.isTerrainActive,
      terrainExaggeration: state.terrainExaggeration,
      setTerrainActive: state.setTerrainActive,
      setTerrainExaggeration: state.setTerrainExaggeration,
    }),
    shallow // Passa shallow come funzione di comparazione
  );

  const handleTerrainToggle = () => {
    setTerrainActive(!isTerrainActive); // Inverte lo stato corrente
  };

  const handleExaggerationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(event.target.value);
    setTerrainExaggeration(value);
  };

  // Gli stili inline sono rimossi per utilizzare le classi CSS come in StylePropertyInput
  
  return (
    // Applica uno stile di base al pannello se necessario, o lascia che sia gestito da CSS esterni
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-medium, 1rem)' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {/* La Label esterna è rimossa perché ToggleButton ha la sua prop label */}
        <ToggleButton
          id="terrain-toggle"
          isOn={isTerrainActive}
          onToggle={handleTerrainToggle}
          label="Enable 3D Terrain"
        />
      </div>

      {isTerrainActive && (
        <div className="style-control"> {/* Classe usata da StylePropertyInput */}
          <label htmlFor="terrain-exaggeration" className="style-label"> {/* Classe usata da StylePropertyInput */}
            Vertical Ex.
          </label>
          <div className="style-control-input-wrapper"> {/* Classe usata da StylePropertyInput */}
            <RangeSlider
              id="terrain-exaggeration"
              min={0}
              max={5}
              step={0.1}
              value={terrainExaggeration}
              onChange={handleExaggerationChange}
              disabled={!isTerrainActive}
              showValueDisplay={true} // Abilita la visualizzazione interna del valore
              formatValueDisplay={(value) => `${Number(value).toFixed(1)}x`} // Formatta il valore
            />
          </div>
          {/* Lo span custom per il valore è rimosso, RangeSlider ora lo gestisce */}
        </div>
      )}
    </div>
  );
};

export default TerrainPanel;